export default "/assets/images/pc-carbon.eaf94ea3ecacd52d.png";